var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-container"},[_c('ReportTab'),_c('div',{staticClass:"content-container"},[(_vm.$store.state.reportForming.selectedTab == 0)?_c('ReportPeriodicContent'):_c('ReportMomentContent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }